import { render, staticRenderFns } from "./Notecatcher.vue?vue&type=template&id=5955263c&scoped=true&"
import script from "./Notecatcher.vue?vue&type=script&lang=js&"
export * from "./Notecatcher.vue?vue&type=script&lang=js&"
import style0 from "./Notecatcher.vue?vue&type=style&index=0&id=5955263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955263c",
  null
  
)

export default component.exports